// extracted by mini-css-extract-plugin
module.exports = {"fill-color":"Star_fill-color__IGolW","empty-color":"Star_empty-color__3_lYu"};